import styled from "styled-components";

export const ContainerList = styled.div`
    width: 92.5%;
    max-width: 650px;

    margin: 0 auto;
`

export const List = styled.ul`
    display: flex;
    flex-direction: column;

    gap: 15px;
    padding: 20px;
    margin-bottom: 50px;
    
    border-radius: 5px;
    
    background-color: var(--grey-3);
`

export const ListEmpty = styled.h2`
    font-size: 18px;
    font-weight: 500;
    
    text-align: center;

    color: var(--grey-0);
`